import React from 'react';
import Head from '../components/Head';
import HeaderOne from '../header/HeaderOne';
import HomeHero from '../components/HomeHero';
import HomeLogos from '../components/HomeLogos';
import HomeHowItWorks from '../components/HomeHowItWorks';
import HomeFeatures from '../components/HomeFeatures';
import HomePricing from '../components/HomePricing';
import HomeMetrics from '../components/HomeMetrics';
import HomeCtaHub from '../components/HomeCtaHub';
import HomeFAQ from '../components/HomeFAQ';
import HomeFinalCta from '../components/HomeFinalCta';
import StickyBottomCta from '../components/StickyBottomCta';
import FooterOne from '../footer/FooterOne';
import ChatBubble from '../components/ChatBubble';

export default function Home() {
  return (
    <>
      <Head
        title="Android SMS Gateway from $0.001 — Skip 10DLC"
        description="TextLink turns any Android phone into an SMS gateway. Send messages through your own SIM from $0.001 per SMS — up to 95% cheaper than Twilio. No 10DLC, no A2P registration. Native GoHighLevel integration."
        canonical="/"
      />
      <HeaderOne />
      <main>
        <HomeHero />
        <HomeLogos />
        <HomeHowItWorks />
        <HomeFeatures />
        <HomePricing />
        <HomeMetrics />
        <HomeCtaHub />
        <HomeFAQ />
        <HomeFinalCta />
      </main>
      <FooterOne />
      <ChatBubble />
      <StickyBottomCta />
    </>
  );
}
